import VSelect from './vueSelect.js';
import loadChartComponents from './charts.js';

export default {
    install(app) {
        app.component('v-select', VSelect);
        app.use(loadChartComponents);
    }
};
